import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 22ECB099-6A57-4DA8-9E42-0E3D8000C003
 * name checkbox-blank-badge
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbox-blank-badge.svg
 * tags
 * - Notification 
 * - Form 
 */
export const CheckboxBlankBadgeIcon = createSvgIcon(<><path d="M23 4.5C23 6.43 21.43 8 19.5 8S16 6.43 16 4.5 17.57 1 19.5 1 23 2.57 23 4.5M19.5 10C16.47 10 14 7.53 14 4.5C14 4 14.08 3.5 14.21 3H5C3.89 3 3 3.89 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V9.79C20.5 9.92 20 10 19.5 10Z" /></>, 'CheckboxBlankBadgeIcon');
export default CheckboxBlankBadgeIcon